import {
	USER_SEGMENTATION_TEAM_TYPE_MARKETING,
	USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
	type UserSegmentationTeamTypes,
} from '../../utils/user-segmentation/index.tsx';

export const ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION: UserSegmentationTeamTypes[] = [
	USER_SEGMENTATION_TEAM_TYPE_MARKETING,
	USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
];

// Using spec from: https://sourcegraph-frontend.prod.services.kitt-inf.net/stash.atlassian.com/JIRACLOUD/jira/-/blob/jira-domains/platform/platform-misc/jira-personalisation-module/src/main/java/com/atlassian/jira/personalisation/data/variants/TeamType.java
export const ELIGIBLE_TEAM_TYPES_M2P5_PERSONALISATION_VARIANTS_NOTATION: string[] = [
	'itSupport',
	'software',
	'other',
	'design',
	'projectManagement',
	'productManagement',
];
